export default {
  queued: "Queued",
  sent: "Sent",
  failed: "Failed",
  delivered: "Delivered",
  undelivered: "Undelivered",
  rejected: "Rejected",
  i: "Initialized"
};
